import React, { FC, memo } from 'react';

import { CheckboxProps, Checkbox as MuiCheckbox } from '@mui/material';

import useStyles from './styles.module';

const Checkbox: FC<CheckboxProps> = ({ checked, ...props }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.box}>
      <MuiCheckbox
        {...props}
        inputProps={{ 'aria-label': 'controlled' }}
        checked={checked}
      />
    </div>
  );
};

export default memo(Checkbox);
